import Badge from 'react-bootstrap/Badge';
import { useTranslation } from 'react-i18next';

const USER_STATUSES = {
    ACTIVE: {
        text: 'active',
        style: 'success'
    },
    INACTIVE: {
        text: 'inactive',
        style: 'secondary'
    },
};


const UserStatus = ({ status, className }) => {
    const { t } = useTranslation();
    const s = USER_STATUSES[status] || {
        text: "unknown",
        style: "secondary"
    };
    const translated = t(`user.status.${s.text}`)
    return <Badge bg={s.style} className={className}>{translated}</Badge>
};

export { USER_STATUSES, UserStatus };

